<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="false"
      [title]="'Integrations'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [isPrimaryLayer]="true" [hasBottomNav]="!windowService.isDesktopRes">
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />

    @if (windowService.isDesktopRes) {
      <tidy-desktop-header [isLoading]="!loaded">
        <div class="wrappable-container">
          <tidy-text
            [title]="'Integrations'" />
        </div>
      </tidy-desktop-header>
    }

    @if (loaded) {
      <tidy-row [align]="'center'">
        <tidy-text
          [body]="'Integrate with an HRIS system if you want to sync your list of employees into TIDY for easier management.'" />
      </tidy-row>
      <tidy-button
        [text]="'Add Integrations'"
        class="primary"
        [action]="boundOpenMergeLink" />
    }
  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [isfullWidthContent]="true" [templateContent]="content" [desktopWidthContent]="desktopWidthContent" />
